import { Row, Col, Skeleton } from 'antd';

const Filters = () => {
    return (
        <Row
            className="loading-filters"
            gutter={30}
            justify="end"
        >
            <Col>
                <Skeleton.Button
                    className="search"
                    active
                />
            </Col>

            <Col>
                <Skeleton.Button
                    className="filters-toggle"
                    active
                />
            </Col>

            <Col>
                <Skeleton.Button
                    className="sort"
                    active
                />
            </Col>

            <Col>
                <Skeleton.Button className="add" active />
            </Col>
        </Row>
    );
};

export default Filters;
